import {
  useGetUserSearchPreferencesQuery,
  useSetUserSearchPreferencesMutation,
} from './api'
import { defaultUserSearchPreferences } from './defaults'
import { mapLocalToDataGrid } from './mapSearchSettings'
import type { UserSearchPreferences } from './types'

export const useUserPreferences = () => {
  const { data: userSearchPreferencesFromServer, ...getRequest } =
    useGetUserSearchPreferencesQuery()

  const [setSearchPreferences, setRequest] =
    useSetUserSearchPreferencesMutation()

  const searchPreferences =
    userSearchPreferencesFromServer ?? defaultUserSearchPreferences

  const updateUserSearchPreferences = (
    updatedPreferences: Partial<UserSearchPreferences>,
  ) => {
    const newPrefs = Object.assign({}, searchPreferences, updatedPreferences)
    if (JSON.stringify(searchPreferences) !== JSON.stringify(newPrefs))
      setSearchPreferences(newPrefs)
  }

  const settings = {
    searchPreferences,
    datagrid: mapLocalToDataGrid(searchPreferences),
  }

  return { ...settings, updateUserSearchPreferences, getRequest, setRequest }
}
